export default {
    networks: [
		{ id: 42161, text: `Arbitrum` },
		{ id: 10, text: `Optimism` },
		{ id: 1, text: `Ethereum` },
        { id: 56, text: `Binance Smart Chain` },	
		{ id: 137, text: `Polygon` },
		{ id: 250, text: `Fantom Opera` },
		{ id: 43114, text: `Avalance C-Chain` }
    ],
    scam_tokens: [
        "0x0e262b466c1d357074a37256c151263a702bff36",
        "0xc33fc11b55465045b3f1684bde4c0aa5c5f40124",
        "0x2fb21d4792fed8e80c38956d8d0f7bf6f298c79c",
        "0x99ac60aa8d2e741662278c452499458aebc2fc26",
        "0x2b4fa56675d129b97f60c598fc308ad8577c592d",
        "0x2744861accb5bd435017c1cfee789b6ebab42082",
        "0x0b91b07beb67333225a5ba0259d55aee10e3a578",
        "0x373233a38ae21cf0c4f9de11570e7d5aa6824a1e",
        "0x81067076dcb7d3168ccf7036117b9d72051205e2",
        "0xd75ad81428127cc3a82637965049613858e6de30",
        "0xecdff6fd2f184f8b8987682a10aa6890ca74c5a8",
        "0x3fa15ff4f208415a78d9ab9db7ea51d9a5809a2b",
        "0xd8e376e3b3630b1790fb9a79d91732f568bccbe1",
        "0xbbffa24ccf2d4d9e9737b1ba4a25a5effa71451e",
        "0x5558447b06867ffebd87dd63426d61c868c45904",
        "0xbc6675de91e3da8eac51293ecb87c359019621cf",
        "0xd5e3bf9045cfb1e6ded4b35d1b9c34be16d6eec3",
        "0x119e2ad8f0c85c6f61afdf0df69693028cdc10be",
        "0xb0557906c617f0048a700758606f64b33d0c41a6",
        "0x0df62d2cd80591798721ddc93001afe868c367ff",
        "0x569b2cf0b745ef7fad04e8ae226251814b3395f9",
        "0x5190b01965b6e3d786706fd4a999978626c19880",
        "0x8ee3e98dcced9f5d3df5287272f0b2d301d97c57",
        "0xd22202d23fe7de9e3dbe11a2a88f42f4cb9507cf",
        "0x0198be93b7cae38da7e2fd966946412cc36447bf",
        "0x4ceaafd1b2e5464e221c5cb3bdce5fb4629b7aae",
        "0xba20edcea5415ce8385e53c629bdbfc13d8a00d8",
        "0x3051cfb958dcd408fba70256073adba943fdf552",
        "0x71aff23750db1f4edbe32c942157a478349035b2",
        "0x4695e4dd1e3011045573f6e16dc162687cdbac44",
        "0xc242b6a3983e90d279ed68ac70f47cfc7e5e1e1c",
        "0x00da7a2b74a3644c31cc24e2e7c29eeca2516980",
        "0x016c285d5b918b92aa85ef1e147498badfe30d69",
        "0x0778a54cefe9f05df4216506807536492deb3c8a",
        "0x0b34d4a7c5bfc7004b9a193f8309523e99ca766e",
        "0x0da6ed8b13214ff28e9ca979dd37439e8a88f6c4",
        "0x246cccb62dbcb08b4abd33790e61068c3f507940",
        "0x27a801ba58644d93a939daa506a56f95c351eddc",
        "0x3a44360038b9a4cf7282bd3150584307e8d0e32a",
        "0x3a5cb7cad29afbfeea77a291fcbe2a636947b09a",
        "0x43a167b15a6f24913a8b4d35488b36ac15d39200",
        "0x4d1d6d8aefb6723ead03d34054a400b9fd303317",
        "0x50fba487ed4bb696e15166343f138509e49263b6",
        "0x735ebe3ed47877a11023b904054a0ffe44e91ab7",
        "0x740b40760266d54362c222c0490a95cf970cd199",
        "0x97c68508672591f78bda7e1436b3ca6683338d56",
        "0x9fa364da44be5f6c6fd9076178f52c9d0bd7e4f7",
        "0xa1fd12820f0c1c492dd87f8a0d12043d8f24f8a6",
        "0xc2f9d07f63c2ca2b4c0c37a2b0fe217ce4ba99b5",
        "0xe32328661c7d7ef5ed7c456d2ec3202c4201c1aa",
        "0xfd79a19b3ebb5509241b0516d9b1fbc6e1dc34ff",
        "0xe4fb1bb8423417a460286b0ed44b64e104c5fae5",
        "0xa85f8a198d59f0fda82333be9aeeb50f24dd59ff",
        "0x0b91b07beb67333225a5ba0259d55aee10e3a578",
        "0x81067076dcb7d3168ccf7036117b9d72051205e2",
        "0xcbf4ab00b6aa19b4d5d29c7c3508b393a1c01fe3",
        "0x0364c8dbde082372e8d6a6137b45613dd0f8138a",
        "0x19a935cbaaa4099072479d521962588d7857d717",
        "0x7e4c577ca35913af564ee2a24d882a4946ec492b",
        "0x89a468488af91f89a31f4ea433be730c83f73dc8",
        "0x8ae127d224094cb1b27e1b28a472e588cbcc7620",
        "0x8d0da9067145de3bd9f3e8bc3ed9fa384f851f7a",
        "0xc16230f1ffc6108923e439265a3a88f2ee4c770d",
        "0xd7f1d4f5a1b44d827a7c3cc5dd46a80fade55558"
    ]
}